// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1iwCV","name":"styles__name___TgItJ"};